import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../components/common/Error/Error";
import Loading from "../../components/common/Loading/Loading";
import {fetchApp} from '../../store/apps/actions';
import style from '../../styles/styles';
import styles from './EditNewsMediaPage.css';
import {fetchOneNews, putOneNewsMedia, fetchOneNewsMedia} from "../../store/news/actions";
import {getMediaTypes} from "../../store/mediatypes/actions";
import MediaForm from "../../components/media/MediaForm/MediaForm";
import withTranslation from "../../hoc/withTranslation";

export class EditNewsMediaPage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
        news: PropTypes.object,
        media: PropTypes.object
    };

    static defaultProps = {
        mediaTypes: []
    };

    componentWillMount() {
        this.fetch();
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.match !== nextProps.match) {
            this.fetch(nextProps.match.params.appId, nextProps.match.params.newsId, nextProps.match.params.mediaId)
        }

        if (this.props.sending && !nextProps.sending) {
            this.props.history.goBack();
        }

        if (nextProps.app && this.props.mediaTypes.count === 0) {
            this.fetchMediaTypes(nextProps.app.id);
        }

        if (nextProps.app && this.props.app !== nextProps.app && this.props.news === null) {
            this.fetchOneNews(nextProps.app.id, nextProps.match.params.newsId);
        }

        if (nextProps.app && nextProps.entity && this.props.entity !== nextProps.entity) {
            this.fetchMedia(nextProps.app.id, nextProps.news.id, nextProps.match.params.mediaId);
        }

    }

    // Fetch

    fetch(appId = null, newsId = null, mediaId = null) {
        this.fetchApplication(appId);
        this.fetchOneNews(appId, newsId);
        this.fetchMedia(appId, newsId, mediaId);
        this.fetchMediaTypes(appId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchOneNews(appId = null, newsId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const news = newsId || this.props.match.params.newsId;

            if (app && news) {
                this.props.fetchOneNews(app, news, this.props.lang);
            }
        }
    }

    fetchMediaTypes(appId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;

            if (app) {
                this.props.getMediaTypes(app);
            }
        }
    }

    fetchMedia(appId = null, newsId = null, mediaId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const news = newsId || this.props.match.params.newsId;
            const media = mediaId || this.props.match.params.mediaId;

            if (app && news && media) {
                this.props.fetchOneNewsMedia(app, news, media, this.props.lang);
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.putOneNewsMedia(this.props.app.id, this.props.news.id, formProps, this.props.lang);
    };

    // Render

    renderForm() {
        return (
            <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">

                <Paper style={styles.editBox}>
                    <Subheader style={style.subHeader}>{this.props.media.picture}</Subheader>
                    <div style={style.paper}>
                        <MediaForm
                            onSubmit={this.handleFormSubmit}
                            initialValues={this.props.initialValues}
                            submitting={this.props.sending}
                            media={this.props.media}
                            mediaTypes={this.props.mediaTypes}
                        />
                    </div>
                    <div style={style.clear} />
                </Paper>
            </div>
        );
    }

    render() {
        if (this.props.error) {
            return (
                <Error
                    title={this.props.t('generic.error')}
                    subtitle={this.props.t('generic.error_loading')}
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.news || !this.props.media) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>{this.props.t('medias.media')} / {this.props.t('generic.edit')} - {this.props.news.title} - {this.props.media.name} ({this.props.media.mime_type})</h3>
                    <div className="row">
                        {this.renderForm()}
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.news.pending || state.mediaTypes.pending,
        error: state.news.error || state.apps.error,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.news.sending,
        mediaTypes: state.mediaTypes.content,
        news: state.news.currentNews,
        media: state.news.currentMedia
    };

    if (props.media) {
        props.initialValues = props.media;
    }

    return props;
}

export default connect(mapStateToProps, {
    getMediaTypes,
    putOneNewsMedia,
    fetchApp,
    fetchOneNews,
    fetchOneNewsMedia
})(withTranslation(EditNewsMediaPage));



// WEBPACK FOOTER //
// src/containers/news/EditNewsMediaPage.js